<template>
  <div>
    <div class="dashboard__tab">
      <b-tabs>
        <b-tab title="All Listings" active>
          <div class="success__wrap" v-if="success">
            <span class="success">{{ successMessage }}</span>
            <svgicon icon="cancel" class="success__icon"></svgicon>
          </div>
          <select
            name=""
            v-model="sort"
            id=""
            class="form__select dashboard__filter"
          >
            <option :value="null" disabled selected>Filter</option>
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="published">Published</option>
            <option value="declined">Declined</option>
            <option value="updated">Updated</option>
            <option value="deactivated">Deactivated</option>
            <option value="unavailable">Unavailable</option>
            <option value="awaiting approval">Awaiting Approval</option>
          </select>
          <div class="dashboard__container ">
            <input
              type="text"
              class="form__input dashboard__search"
              v-model="searchQuery"
              placeholder="Search by space name"
              @keyup.enter="handleSearchListing"
            />
            <svgicon
              icon="cancel"
              class="cancel_icon"
              @click.prevent="clearSearchBar"
            ></svgicon>
          </div>
          <div v-if="showMultipleDelete" class="dashboard-delete-container">
            <p class="clear-selection" @click="clearMultipleSelection">
              Clear Selection
            </p>
            <div class="delete-left">
              <p class="selected">{{ multipleSelectedIds.length }} selected</p>
              <button class="delete-button" @click="deleteMultipleSpaces">
                <div class="delete-left">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 18C2.45 18 1.97934 17.8043 1.588 17.413C1.19667 17.0217 1.00067 16.5507 1 16V3C0.71667 3 0.479337 2.904 0.288004 2.712C0.0966702 2.52 0.000670115 2.28267 3.44827e-06 2C-0.000663218 1.71733 0.0953369 1.48 0.288004 1.288C0.48067 1.096 0.718003 1 1 1H5C5 0.716667 5.096 0.479333 5.288 0.288C5.48 0.0966668 5.71734 0.000666667 6 0H10C10.2833 0 10.521 0.0960001 10.713 0.288C10.905 0.48 11.0007 0.717333 11 1H15C15.2833 1 15.521 1.096 15.713 1.288C15.905 1.48 16.0007 1.71733 16 2C15.9993 2.28267 15.9033 2.52033 15.712 2.713C15.5207 2.90567 15.2833 3.00133 15 3V16C15 16.55 14.8043 17.021 14.413 17.413C14.0217 17.805 13.5507 18.0007 13 18H3ZM13 3H3V16H13V3ZM6 14C6.28334 14 6.521 13.904 6.713 13.712C6.905 13.52 7.00067 13.2827 7 13V6C7 5.71667 6.904 5.47933 6.712 5.288C6.52 5.09667 6.28267 5.00067 6 5C5.71734 4.99933 5.48 5.09533 5.288 5.288C5.096 5.48067 5 5.718 5 6V13C5 13.2833 5.096 13.521 5.288 13.713C5.48 13.905 5.71734 14.0007 6 14ZM10 14C10.2833 14 10.521 13.904 10.713 13.712C10.905 13.52 11.0007 13.2827 11 13V6C11 5.71667 10.904 5.47933 10.712 5.288C10.52 5.09667 10.2827 5.00067 10 5C9.71734 4.99933 9.48 5.09533 9.288 5.288C9.096 5.48067 9 5.718 9 6V13C9 13.2833 9.096 13.521 9.288 13.713C9.48 13.905 9.71734 14.0007 10 14Z"
                      fill="#EA4335"
                    />
                  </svg>
                  <p>Delete selected listings</p>
                </div>
              </button>
            </div>
          </div>

          <section class="dashboard__listing-desktop">
            <div
              class="dashboard__payment-history-wrap dashboard__overview-table"
              v-if="listings.length > 0"
            >
              <table class="dashboard__payment-history-table">
                <thead>
                  <tr>
                    <th class="dashboard__payment-history-table-heading"></th>
                    <th class="dashboard__payment-history-table-heading"></th>
                    <th class="dashboard__payment-history-table-heading"></th>
                    <th class="dashboard__payment-history-table-heading">
                      Space name
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Space type
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Sub type
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Location
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Status
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Date updated
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(listing, index) in searchTable(filteredListing)"
                    :key="index"
                  >
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <CustomCheck
                        :val="listing.id"
                        :model-value="multipleSelectedIds"
                        @change="updatedMultipleId"
                      />
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{ pageNumber(index + 1) }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <div
                        v-if="listing.images.length > 0"
                        class="dashboard__listing-img"
                        :style="{
                          backgroundImage:
                            'url(' + listing.images[0].image_path + ')'
                        }"
                      ></div>
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{
                        (listing.title == null ? "-----" : listing.title)
                          | capitalize
                      }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{ listing.listing_type | capitalize }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <p class="mb-0">
                        {{
                          listing.sub_type_code === "beachHouse"
                            ? "Beach House"
                            : listing.sub_type_code
                        }}
                      </p>
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{ listing.city | capitalize }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <span
                        class="listing__status"
                        :class="[
                          { pending: listing.status == 'pending' },
                          { updated: listing.status == 'updated' },
                          { declined: listing.status == 'declined' },
                          { published: listing.status == 'published' },
                          {
                            awaiting_approval:
                              listing.status == 'awaiting approval'
                          },
                          { unavailable: listing.status == 'unavailable' },
                          { deactivated: listing.status == 'deactivated' }
                        ]"
                        >{{ listing.status | capitalize }}</span
                      >
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                      v-html="formatDate(listing.updated_at)"
                    ></td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <b-dropdown
                        id="dropdown-left"
                        size="lg"
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                      >
                        <template v-slot:button-content>
                          <svgicon
                            icon="table-menu"
                            class="dashboard__listing-table-menu"
                          ></svgicon>
                        </template>
                        <b-dropdown-item @click="handleViewListing(listing)"
                          >View</b-dropdown-item
                        >
                        <b-dropdown-item-button
                          v-if="
                            listing.status == 'awaiting approval' ||
                              listing.status == 'updated'
                          "
                          @click="approveListing(listing.id)"
                          >Publish</b-dropdown-item-button
                        >
                        <b-dropdown-item-button
                          v-if="
                            listing.status == 'awaiting approval' ||
                              listing.status == 'updated'
                          "
                          @click="toggleDisapprovemodal(listing.id)"
                          >Decline</b-dropdown-item-button
                        >
                        <b-dropdown-item
                          v-if="listing.status == 'published'"
                          @click="deactivateListing(listing.id)"
                          >Deactivate</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-if="
                            listing.status == 'deactivated' ||
                              listing.status == 'unavailable'
                          "
                          @click="activateListing(listing.id)"
                          >{{
                            listing.status === "unavailable"
                              ? "Make Available"
                              : "Activate"
                          }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="deleteListings(listing.id)"
                          >Delete</b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section class="dashboard__listing-mobile" v-if="listings.length > 0">
            <div
              class="dashboard__payment-history-resp"
              v-for="(listing, index) in searchTable(filteredListing)"
              :key="index"
            >
              <div class="dashboard__listing-mobile-wrap">
                <div
                  v-if="listing.images.length > 0"
                  class="dashboard__listing-img mr-5"
                  :style="{
                    backgroundImage: 'url(' + listing.images[0].image_path + ')'
                  }"
                ></div>
                <div class="dashboard__listing-mobile-detail">
                  <div class="dashboard__payment-history-resp-details">
                    <p class="dashboard__payment-history-resp-name">
                      {{
                        (listing.title == null ? "-----" : listing.title)
                          | capitalize
                      }}
                    </p>
                    <p class="dashboard__payment-history-resp-others">
                      {{ listing.listing_type | capitalize }}
                    </p>
                  </div>
                  <div class="dashboard__payment-history-resp-details">
                    <p class="dashboard__payment-history-resp-name">
                      {{
                        listing.sub_type_code === "beachHouse"
                          ? "Beach House"
                          : listing.sub_type_code
                      }}
                    </p>
                    <p class="dashboard__payment-history-resp-others">
                      {{ listing.city | capitalize }}
                    </p>
                  </div>

                  <div class="dashboard__payment-history-resp-download">
                    <span
                      class="listing__status"
                      :class="[
                        { pending: listing.status == 'pending' },
                        { updated: listing.status == 'updated' },
                        { declined: listing.status == 'declined' },
                        { published: listing.status == 'published' },
                        {
                          awaiting_approval:
                            listing.status == 'awaiting approval'
                        },
                        { unavailable: listing.status == 'unavailable' },
                        { deactivated: listing.status == 'deactivated' }
                      ]"
                      >{{ listing.status | capitalize }}</span
                    >

                    <b-dropdown
                      id="dropdown-right"
                      right
                      size="lg"
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <svgicon
                          icon="table-menu"
                          class="dashboard__listing-table-menu"
                        ></svgicon>
                      </template>
                      <b-dropdown-item
                        :to="
                          `/member-details/${listing.user_id}?page=${curPage}`
                        "
                        >View</b-dropdown-item
                      >
                      <b-dropdown-item-button
                        v-if="
                          (!listing.is_published || listing.is_published) &&
                            (listing.approval_status == 'pending' ||
                              listing.approval_status == 'disapproved')
                        "
                        @click="approveListing(listing.id)"
                        >Approve</b-dropdown-item-button
                      >
                      <b-dropdown-item-button
                        v-if="
                          (!listing.is_published || listing.is_published) &&
                            (listing.approval_status == 'pending' ||
                              listing.approval_status == 'approved')
                        "
                        @click="toggleDisapprovemodal(listing.id)"
                        >Decline</b-dropdown-item-button
                      >
                      <b-dropdown-item
                        v-if="
                          listing.is_published && listing.status == 'active'
                        "
                        @click="deactivateListing(listing.id)"
                        >Deactivate</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="
                          listing.is_published &&
                            (listing.status == 'inactive' ||
                              listing.status == 'pending' ||
                              listing.status == 'completed') &&
                            listing.approval_status == 'approved'
                        "
                        @click="activateListing(listing.id)"
                        >Activate</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Empty listing result -->
          <div v-if="!loader && listings.length === 0 && !error">
            <empty-result />
          </div>
          <!-- error-->
          <div v-if="!loader && error">
            <error />
          </div>

          <div class="dashboard__pagination">
            <b-pagination
              v-if="listings.length > 0"
              pills
              v-model="curPage"
              :total-rows="count"
              :per-page="pageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination"
            ></b-pagination>
          </div>
        </b-tab>

        <b-tab title="Pending host kyc listings">
          <section class="dashboard__listing-desktop">
            <div
              class="dashboard__payment-history-wrap dashboard__overview-table"
              v-if="listings.length > 0"
            >
              <table class="dashboard__payment-history-table">
                <thead>
                  <tr>
                    <th class="dashboard__payment-history-table-heading"></th>
                    <th class="dashboard__payment-history-table-heading">
                      Space name
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Space type
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Sub type
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Location
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Status
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Date updated
                    </th>
                    <th class="dashboard__payment-history-table-heading">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(listing, index) in unapprovedHostKYC"
                    :key="index"
                  >
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <div
                        v-if="listing.images.length > 0"
                        class="dashboard__listing-img"
                        :style="{
                          backgroundImage:
                            'url(' + listing.images[0].image_path + ')'
                        }"
                      ></div>
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{
                        (listing.title == null ? "-----" : listing.title)
                          | capitalize
                      }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{ listing.listing_type | capitalize }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <p class="mb-0">
                        {{
                          listing.sub_type_code === "beachHouse"
                            ? "Beach House"
                            : listing.sub_type_code
                        }}
                      </p>
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      {{ listing.city | capitalize }}
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <span
                        class="listing__status"
                        :class="[
                          { pending: listing.status == 'pending' },
                          { updated: listing.status == 'updated' },
                          { declined: listing.status == 'declined' },
                          { published: listing.status == 'published' },
                          {
                            awaiting_approval:
                              listing.status == 'awaiting approval'
                          },
                          { unavailable: listing.status == 'unavailable' },
                          { deactivated: listing.status == 'deactivated' }
                        ]"
                        >{{ listing.status | capitalize }}</span
                      >
                    </td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                      v-html="formatDate(listing.updated_at)"
                    ></td>
                    <td
                      class="dashboard__payment-history-table-data dashboard__listing-table"
                    >
                      <b-dropdown
                        id="dropdown-left"
                        size="lg"
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                      >
                        <template v-slot:button-content>
                          <svgicon
                            icon="table-menu"
                            class="dashboard__listing-table-menu"
                          ></svgicon>
                        </template>
                        <b-dropdown-item
                          :to="
                            `/member-details/${listing.user_id}?page=${curPage}`
                          "
                          >Review KYC</b-dropdown-item
                        >
                        <b-dropdown-item-button
                          v-if="
                            (!listing.is_published || listing.is_published) &&
                              (listing.approval_status == 'pending' ||
                                listing.approval_status == 'disapproved')
                          "
                          @click="approveListing(listing.id)"
                          >Approve</b-dropdown-item-button
                        >
                        <b-dropdown-item-button
                          v-if="
                            (!listing.is_published || listing.is_published) &&
                              (listing.approval_status == 'pending' ||
                                listing.approval_status == 'approved')
                          "
                          @click="toggleDisapprovemodal(listing.id)"
                          >Decline</b-dropdown-item-button
                        >
                        <b-dropdown-item
                          v-if="
                            listing.is_published && listing.status == 'active'
                          "
                          @click="deactivateListing(listing.id)"
                          >Deactivate</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-if="
                            listing.is_published &&
                              (listing.status == 'inactive' ||
                                listing.status == 'pending' ||
                                listing.status == 'completed') &&
                              listing.approval_status == 'approved'
                          "
                          @click="activateListing(listing.id)"
                          >Activate</b-dropdown-item
                        >
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section class="dashboard__listing-mobile" v-if="listings.length > 0">
            <div
              class="dashboard__payment-history-resp"
              v-for="(listing, index) in unapprovedHostKYC"
              :key="index"
            >
              <div class="dashboard__listing-mobile-wrap">
                <div
                  v-if="listing.images.length > 0"
                  class="dashboard__listing-img mr-5"
                  :style="{
                    backgroundImage: 'url(' + listing.images[0].image_path + ')'
                  }"
                ></div>
                <div class="dashboard__listing-mobile-detail">
                  <div class="dashboard__payment-history-resp-details">
                    <p class="dashboard__payment-history-resp-name">
                      {{
                        (listing.title == null ? "-----" : listing.title)
                          | capitalize
                      }}
                    </p>
                    <p class="dashboard__payment-history-resp-others">
                      {{ listing.listing_type | capitalize }}
                    </p>
                  </div>
                  <div class="dashboard__payment-history-resp-details">
                    <p class="dashboard__payment-history-resp-name">
                      {{
                        listing.sub_type_code === "beachHouse"
                          ? "Beach House"
                          : listing.sub_type_code
                      }}
                    </p>
                    <p class="dashboard__payment-history-resp-others">
                      {{ listing.city | capitalize }}
                    </p>
                  </div>

                  <div class="dashboard__payment-history-resp-download">
                    <span
                      class="listing__status"
                      :class="[
                        { pending: listing.status == 'pending' },
                        { updated: listing.status == 'updated' },
                        { declined: listing.status == 'declined' },
                        { published: listing.status == 'published' },
                        {
                          awaiting_approval:
                            listing.status == 'awaiting approval'
                        },
                        { unavailable: listing.status == 'unavailable' },
                        { deactivated: listing.status == 'deactivated' }
                      ]"
                      >{{ listing.status | capitalize }}</span
                    >

                    <b-dropdown
                      id="dropdown-right"
                      right
                      size="lg"
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <svgicon
                          icon="table-menu"
                          class="dashboard__listing-table-menu"
                        ></svgicon>
                      </template>
                      <b-dropdown-item
                        :to="
                          `/member-details/${listing.user_id}?page=${curPage}`
                        "
                        >View</b-dropdown-item
                      >
                      <b-dropdown-item-button
                        v-if="
                          (!listing.is_published || listing.is_published) &&
                            (listing.approval_status == 'pending' ||
                              listing.approval_status == 'disapproved')
                        "
                        @click="approveListing(listing.id)"
                        >Approve</b-dropdown-item-button
                      >
                      <b-dropdown-item-button
                        v-if="
                          (!listing.is_published || listing.is_published) &&
                            (listing.approval_status == 'pending' ||
                              listing.approval_status == 'approved')
                        "
                        @click="toggleDisapprovemodal(listing.id)"
                        >Decline</b-dropdown-item-button
                      >
                      <b-dropdown-item
                        v-if="
                          listing.is_published && listing.status == 'active'
                        "
                        @click="deactivateListing(listing.id)"
                        >Deactivate</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="
                          listing.is_published &&
                            (listing.status == 'inactive' ||
                              listing.status == 'pending' ||
                              listing.status == 'completed') &&
                            listing.approval_status == 'approved'
                        "
                        @click="activateListing(listing.id)"
                        >Activate</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </b-tab>
      </b-tabs>
    </div>

    <loader :loader="loader"></loader>

    <!-- Disapprove modal -->
    <div
      class="app-modal"
      :class="[showDisapproveModal ? 'show' : 'hide']"
      @click="showDisapproveModal = false"
    >
      <div class="app-modal-content" @click.stop>
        <p class="warning__title">Decline</p>
        <div class="form__group w-100">
          <label for class="form__label"
            >Reason for declining this listing</label
          >
          <textarea
            class="listing__textarea mb-0 p-3 w-100"
            v-model="reasonNote"
          ></textarea>
        </div>
        <div class="form__action-wrap">
          <span @click="toggleDisapprovemodal" class="form__back">Cancel</span>
          <button
            class="cta_btn dashboard__btn d-inline"
            :class="[{ disabled_btn: reasonNote == null || declineLoading }]"
            :disabled="reasonNote == null || declineLoading"
            @click="declineListing(listingId)"
          >
            <svgicon
              v-if="declineLoading"
              icon="spinner"
              class="button__loader"
            ></svgicon>
            Decline
          </button>
        </div>
      </div>
    </div>
    <!-- Disapprove modal -->
    <app-modal
      :show="showPendingModal"
      :styleGotten="modalStyle"
      @onclosed="showPendingModal = false"
    >
      <div class="view-pending-modal">
        <p>SPACE DETAILS</p>
        <div
          class="pending___modal___container"
          v-for="listing in selectedListing"
          :key="listing.id"
        >
          <div class="host___name">
            <p class="label">Host Name</p>
            <p class="name">{{ listing.host_fullname }}</p>
          </div>
          <div class="email___address">
            <p class="label">Email Address</p>
            <p class="address">{{ listing.host_email }}</p>
          </div>
          <div class="phone___number">
            <p class="label">Phone Number</p>
            <p class="number">
              {{ listing.host_phone_number ? listing.host_phone_number : "-" }}
            </p>
          </div>
          <div class="current___step">
            <p class="label">Current Step</p>
            <p class="value">{{ listing.current_step }}</p>
          </div>
          <div class="curent___level">
            <p class="label">Current Level</p>
            <p class="value">{{ listing.current_level }}</p>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</template>

<script>
import {
  getListing,
  approveListing,
  declineListing,
  activateListing,
  deactivateListing,
  deleteListing,
  massDeleteListing
} from "../../../services/listing";
import loader from "../resuables/loader";
import { formatReadbleDate } from "../../utils/index";
import EmptyResult from "../general/emptyResult.vue";
import Error from "../general/error.vue";
import CustomCheck from "../resuables/custom-check.vue";
export default {
  name: "listing",
  components: {
    loader,
    EmptyResult,
    Error,
    CustomCheck
  },
  data() {
    return {
      listings: [],
      numberOfLisitng: null,
      successMessage: "",
      success: false,
      loader: false,
      sort: "all",
      filteredListing: [],
      showDisapproveModal: false,
      showPendingModal: false,
      selectedListing: [],
      listingId: null,
      reasonNote: null,
      declineLoading: false,
      searchQuery: "",
      searchKey: "title",
      error: false,
      page: 1,
      pageSize: 20,
      count: 0,
      unapprovedHostKYC: null,
      status: "",
      modalStyle: {
        "max-width": "507px",
        width: "100%",
        height: "384px",
        padding: "0px"
      },
      multipleSelectedIds: [],
      showMultipleDelete: false
    };
  },
  methods: {
    toggleDisapprovemodal(listingId) {
      this.listingId = listingId;
      this.showDisapproveModal = !this.showDisapproveModal;
    },
    clearSearchBar() {
      this.searchQuery = "";
      this.getListing();
    },
    handleViewListing(listing) {
      const { id, status } = listing;
      this.selectedListing = [];
      if (status === "pending") {
        this.selectedListing.push(listing);
        this.showPendingModal = !this.showPendingModal;
      } else {
        this.$router.push(`listing-details/${id}?page=${this.curPage}`);
      }
    },
    handleSearchListing() {
      this.$router.replace(
        `/listing?page=1&status=${this.status}&listingName=${this.searchQuery}`
      );
      this.getListing();
    },
    pageNumber(index) {
      if (this.page < 2) {
        return index;
      } else {
        return this.pageSize * (this.page - 1) + index;
      }
    },
    getListing() {
      this.loader = true;
      getListing(this.page, this.pageSize, this.status, this.searchQuery)
        .then(data => {
          if (data.statusCode == 200) {
            this.loader = false;
            this.listings = data.data.data;
            this.count = data.data.totalCount;
            this.filteredListing = this.listings;
            this.unapprovedHostKYC = this.listings.filter(kyc => {
              if (
                kyc.host_kyc_status == "pending" ||
                kyc.host_kyc_status == "declined"
              ) {
                return kyc;
              }
            });
            this.unapprovedHostKYC.sort(
              (d1, d2) =>
                new Date(d2.updated_at).getTime() -
                new Date(d1.updated_at).getTime()
            );
            this.filteredListing.sort(
              (d1, d2) =>
                new Date(d2.updated_at).getTime() -
                new Date(d1.updated_at).getTime()
            );
          }
        })
        .catch(err => {
          this.loader = false;
          this.error = true;
          return err;
        });
    },
    handlePagination(value) {
      this.page = value;
      this.$router.push(`/listing?page=${this.page}&status=${this.status}`);
    },
    approveListing(id) {
      approveListing(id)
        .then(data => {
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Listing Approved!",
              description: "You have successfully approved a listing"
            });
            this.getListing();
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: err.response.data.message
          });
          return err;
        });
    },
    declineListing() {
      this.declineLoading = true;
      const reasonNote = {
        decline_reason: this.reasonNote
      };
      declineListing(this.listingId, reasonNote)
        .then(data => {
          if (data.statusCode == 200) {
            this.declineLoading = false;
            this.showDisapproveModal = false;
            this.reasonNote = null;
            this.$notification.success({
              message: "Listing Declined!",
              description: "You have declined a listing"
            });
          } else {
            this.declineLoading = false;
            this.showDisapproveModal = false;
            this.reasonNote = null;
            this.$notification.error({
              message: "Error",
              description: "You are not authorized to perform this action"
            });
          }
          this.getListing();
        })
        .catch(err => {
          this.declineLoading = false;
          this.showDisapproveModal = false;
          return err;
        });
    },
    deleteListings(id) {
      deleteListing(id)
        .then(data => {
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Listing Deleted!",
              description: "You have successfully deleted a listing"
            });
            this.getListing();
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    activateListing(id) {
      activateListing(id)
        .then(data => {
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Listing Activated!",
              description: "You have successfully activated a listing"
            });
            this.getListing();
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: err.response.data.message
          });
          return err;
        });
    },
    deactivateListing(id) {
      deactivateListing(id)
        .then(data => {
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Listing Deactivated!",
              description: "You have successfully deactivated a listing"
            });
            this.getListing();
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    formatDate(date) {
      return formatReadbleDate(date);
    },
    searchTable(searchableRows) {
      let withoutNull = [];
      searchableRows.filter(el => {
        // if (el.title != null) {
        withoutNull.push(el);
        // }
      });
      return withoutNull;
    },
    updatedMultipleId({ id, checked }) {
      this.showMultipleDelete = true;
      if (checked) {
        if (!this.multipleSelectedIds.includes(id)) {
          this.multipleSelectedIds.push(id);
        }
      } else {
        this.multipleSelectedIds = this.multipleSelectedIds.filter(
          item => item !== id
        );
      }

      this.showMultipleDelete = this.multipleSelectedIds.length > 0;
    },
    clearMultipleSelection() {
      this.multipleSelectedIds = [];
      this.showMultipleDelete = false;
    },
    deleteMultipleSpaces() {
      const payload = {
        listingIds: [...this.multipleSelectedIds]
      };
      massDeleteListing(payload)
        .then(data => {
          if (data.statusCode == 200) {
            this.clearMultipleSelection();
            this.$notification.success({
              message: "Listings Deleted!",
              description: `"You have successfully deleted ${this.multipleSelectedIds.length} listings"`
            });
            this.getListing();
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: err.response.data.message
          });
          return err;
        });
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  watch: {
    $route() {
      this.getListing();
    },
    sort(newValue) {
      this.page = 1;
      if (newValue === "all") {
        this.status = "";
        this.$router.replace(`/listing?page=1`);
        this.getListing();
      } else {
        this.status = newValue;
        this.$router.replace(`/listing?page=1&status=${this.status}`);
        this.getListing();
      }
    }
  },
  computed: {
    curPage: {
      get() {
        return Number(this.$route.query.page) || 1;
      },
      set(value) {
        this.page = value;
      }
    }
  },
  mounted() {
    const { page, status, listingName } = this.$route.query;
    if (page) {
      this.page = Number(page);
    }
    if (status) {
      this.status = status;
    }
    if (listingName) {
      this.searchQuery = listingName;
    }
    this.getListing();
  },
  beforeMount() {}
};
</script>
<style scoped lang="css">
.disabled_btn {
  pointer-events: none;
  cursor: not-allowed;
  background-color: rgb(210, 210, 222);
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/listing.vue